export enum MessageContext {
    Conversion = 'conversion',
    WaterTransfers = 'water-transfers',
    LeaverJourney = 'leaver-journey',
    Reviews = 'reviews',
    BrokerSuccess = 'broker-success',
    Clawbacks = 'clawbacks',
    Other = 'other',
}
